import React, { useState } from "react";
import { Modal, DatePicker } from "antd";
import PropTypes from "prop-types";
import Wrapper from "./style";
import { CSVLink } from "react-csv";
import { NotificationManager } from "react-notifications";

const ExportTrans = ({ showModal, hideModal, dataList }) => {
  const [data, setData] = useState({});
  const [filteredData, setFilteredData] = useState([]);

  const handleFilterOperation = () => {
    if (data.startDate && data.endDate) {
      const filtered = dataList.filter(({ acct_opn_date }) => {
        const date = new Date(acct_opn_date);
        return date >= new Date(data.startDate) && date <= new Date(data.endDate);
      });
      setFilteredData(filtered);
    } else {
      NotificationManager.error("Please select date range");
    }
  };

  function formatDate(date) {
    if (!date) return "";
    const d = new Date(date);
    let month = "" + (d.getMonth() + 1);
    let day = "" + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  return (
    <Modal
      visible={showModal}
      closable={false}
      footer={null}
      centered
      onCancel={() => {
        hideModal(false);
      }}
      title=""
      bodyStyle={{
        padding: "23px 73px 44px 73px",
        borderRadius: "12px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
          marginBottom: "27px",
        }}
      >
        <div
          style={{
            cursor: "pointer",
          }}
          onClick={() => {
            hideModal(false);
          }}
        >
          X
        </div>
      </div>
      <Wrapper>
        <div className="title">Export Data</div>
        <div className="cw-content">
          <div className="input-content border-dark">
            <div className="label">Filters</div>
            <select name="" id="" className="border border-dark">
              <option value="">Transaction Date</option>
            </select>
          </div>
          <div className="input-content border-dark">
            <div className="label">Start Date</div>
            <DatePicker 
              onChange={(e) => { 
                setData({ ...data, startDate: formatDate(e) });
              }} 
            />
          </div>
          <div className="input-content ">
            <div className="label" style={{ marginTop: 20 }}>End Date</div>
            <DatePicker 
              onChange={(e) => { 
                setData({ ...data, endDate: formatDate(e) });
              }} 
            />
          </div>
        </div>
      </Wrapper>

      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          marginTop: 50
        }}
      >
        <CSVLink
          data={filteredData}
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            background: "#FF4B01",
            color: "#fff",
            borderRadius: "3px",
            fontSize: "14px",
            lineHeight: "17px",
            display: "flex",
            alignItems: "center",
            padding: "10px 25px",
            textDecoration: "none"
          }}
          filename={"Accounts.csv"}
          onClick={(event, done) => {
            handleFilterOperation();
            done();
          }}
        >
          Export Data
        </CSVLink>
      </div>
    </Modal>
  );
};

ExportTrans.propTypes = {
  showModal: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired,
  dataList: PropTypes.array.isRequired,
};

export default ExportTrans;
